import { z } from 'zod'
import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '../../common'

export const FiscalYearSearchParamsSchema = z
  .object({})
  .merge(BasePaginateParamsSchema)

export type FiscalYearSearchParams = z.infer<
  typeof FiscalYearSearchParamsSchema
>

export const FiscalYearSearchResultModelSchema = z.object({
  id: z.number(),
  code: z.string(),
  startDate: z.string(),
  endDate: z.string(),
  isClosed: z.boolean(),
  periodCount: z.number(),
})

export type FiscalYearSearchResultModel = z.infer<
  typeof FiscalYearSearchResultModelSchema
>

export const FiscalYearSearchResultSchema = z
  .object({
    data: z.array(FiscalYearSearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type FiscalYearSearchResult = z.infer<
  typeof FiscalYearSearchResultSchema
>
